/* Lightweight nav for LP header/footer on main theme pages */
(function () {
  if (window.__MB_LP_NAV__) return;
  window.__MB_LP_NAV__ = true;

  var L = window.MB_LINKS || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* mobile menu */
  var menu = $('#menu'), mbtn = $('.menu-btn'), mscrim = $('#menu-scrim');
  if (menu && mbtn) {
    function place() {
      var r = mbtn.getBoundingClientRect();
      menu.style.top = Math.max(4, r.top - 12) + 'px';
      menu.style.right = Math.max(4, window.innerWidth - r.right - 12) + 'px';
    }
    window.addEventListener('resize', function () { if (!menu.hidden) place(); });
    function openMenu() {
      place();
      menu.hidden = false;
      requestAnimationFrame(function () {
        menu.classList.add('show');
        if (mscrim) mscrim.classList.add('show');
      });
      mbtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('mb-lock');
      var x = $('.menu-x', menu); if (x) x.focus();
    }
    function closeMenu(back) {
      menu.classList.remove('show');
      if (mscrim) mscrim.classList.remove('show');
      mbtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('mb-lock');
      setTimeout(function () { menu.hidden = true; }, 200);
      if (back !== false) mbtn.focus();
    }
    mbtn.addEventListener('click', openMenu);
    var closeBtn = $('.menu-x', menu);
    if (closeBtn) closeBtn.addEventListener('click', function () { closeMenu(); });
    if (mscrim) mscrim.addEventListener('click', function () { closeMenu(); });
    $$('a', menu).forEach(function (a) {
      a.addEventListener('click', function () { closeMenu(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (menu.hidden) return;
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* data-goto purchase / explain links */
  function gotoHref(which, hash) {
    var base = L[which];
    if (!base) return null;
    return base + (hash ? '#' + hash : '');
  }
  $$('[data-goto]').forEach(function (a) {
    var which = a.getAttribute('data-goto');
    if (!L[which]) return;
    function upd() {
      a.href = gotoHref(which, a.getAttribute('data-hash')) || '#';
    }
    upd();
    a.addEventListener('mouseenter', upd);
    a.addEventListener('focus', upd);
  });
})();
